import { getImpersonationToken } from "@/api/axios.ts";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";

export function useAiAssistantAvailable(): boolean {
  const { canIEdit, isFeatureEnabled } = usePermissions();
  return (
    isFeatureEnabled(ApiFeatureType.ai_assistant) &&
    canIEdit(ApiPermission.ai_assistant_module) &&
    !getImpersonationToken()
  );
}
